export default {
  flowableUiApiBaseUrl: process.env.REACT_APP_FLOWABLE_API_BASE_URL,
  flowableAuthClient: "KEYCLOAK-AK-UI",
  classificationBannerText: process.env.REACT_APP_CLASSIFICATION_BANNER_TEXT,
  classificationBannerColorHex: process.env.REACT_APP_CLASSIFICATION_BANNER_COLOR_HEX,
  versionNumber: process.env.REACT_APP_VERSION_NUMBER,
  appName: process.env.REACT_APP_NAME_TEXT,
  sessionTimeout: process.env.REACT_APP_SESSION_TIMEOUT,
  emailAddress: process.env.REACT_APP_EMAIL_ADDRESS,
}